'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["width", "height", "margin", "children", "series", "colors", "dataset", "desc", "onAxisClick", "disableVoronoi", "voronoiMaxRadius", "onItemClick", "disableAxisListener", "highlightedItem", "onHighlightChange", "sx", "title", "xAxis", "yAxis", "zAxis", "rotationAxis", "radiusAxis", "skipAnimation", "seriesConfig", "plugins"];
import { DEFAULT_PLUGINS } from "../internals/plugins/allPlugins.js";
export const useChartContainerProps = (props, ref) => {
  const _ref = props,
    {
      width,
      height,
      margin,
      children,
      series,
      colors,
      dataset,
      desc,
      onAxisClick,
      disableVoronoi,
      voronoiMaxRadius,
      onItemClick,
      disableAxisListener,
      highlightedItem,
      onHighlightChange,
      sx,
      title,
      xAxis,
      yAxis,
      zAxis,
      rotationAxis,
      radiusAxis,
      skipAnimation,
      seriesConfig,
      plugins
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  const chartsSurfaceProps = _extends({
    title,
    desc,
    sx,
    ref
  }, other);
  const chartDataProviderProps = {
    margin,
    series,
    colors,
    dataset,
    disableAxisListener,
    highlightedItem,
    onHighlightChange,
    onAxisClick,
    disableVoronoi,
    voronoiMaxRadius,
    onItemClick,
    xAxis,
    yAxis,
    zAxis,
    rotationAxis,
    radiusAxis,
    skipAnimation,
    width,
    height,
    seriesConfig,
    plugins: plugins ?? DEFAULT_PLUGINS
  };
  return {
    chartDataProviderProps,
    chartsSurfaceProps,
    children
  };
};